import { createSelector } from '@reduxjs/toolkit';

import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';
import { getProjectAttributesByDomain } from 'src/utils/getProjectAttributesByDomain';

export const projectAttributesByDomainSelector = (projectId: string) =>
  createSelector(
    projectAttributesByIriSelector(projectId),
    getProjectAttributesByDomain
  );
